import { FC } from 'react';
import type { ColumnProps } from '../Column';
import Column from '../Column';

interface CalloutHeaderProps extends ColumnProps {}

const CalloutHeader: FC<CalloutHeaderProps> = ({ children, ...props }) => {
    return (
        <Column gap={0} sx={{ p: 2, textAlign: 'center' }} {...props}>
            {children}
        </Column>
    );
};

export type { CalloutHeaderProps };
export default CalloutHeader;
